import { DayHours } from '@models/day-hours.model';
import { ImputationsData } from './../calendar-day/calendar-day.model';
import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ModalDayService } from './modal-day.service';
import { ObservatoryService } from '@services/services.module';
import { Subscription, Subject } from 'rxjs';
import { NotificationsService } from '@services/notifications/notifications.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RangeHourService } from '@app/services/range-hour/range-hour.service';
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-modal-day',
  templateUrl: './modal-day.component.html',
  styleUrls: ['./modal-day.component.scss']
})

export class ModalDayComponent implements OnInit, OnDestroy {

  eventsBorrarHoras: Subject<void> = new Subject<void>();
  @Output() update: EventEmitter<any> = new EventEmitter();
  private subscriptions: Array<Subscription> = [];

  // array de horas
  dayHours: DayHours[];

  sumTempS1: number = 0;
  sumTempS2: number = 0;
  sumTempS3: number = 0;
  sumTempTotal: number = 0;
  workingDay;
  timeInPerson;
  festive;

  // imputaciones originales
  s1 = [];
  s2s3 = [];
  inputDayData;

  // imputaciones modificadas
  modifiedS1 = [];
  modifiedS2S3 = [];
  newDate;

  constructor(
    private _modalDayService: ModalDayService,
    private _observatoryService: ObservatoryService,
    private notification: NotificationsService,
    private modalService: NgbModal,
    private rangeHourService: RangeHourService,
    public translate: TranslateService
  ) { }

  ngOnInit(): void {

    // seteamos la array de horas
    this.dayHours = this.rangeHourService.newArrayHours();
    this.rangeHourService.setDayHours(this.dayHours);

    this.subscriptions.push(
      this._observatoryService.getData('inputDayData').subscribe(data => {
        if (data) {
          this.inputDayData = JSON.parse(JSON.stringify(data));

          this.inputDayData.imputations.forEach(element => {
            if (element.activityTypeId === '1') {
              this.s1.push(element);
            }
            if (element.activityTypeId === '2') {
              this.s2s3.push(element);
            }
            if (element.activityTypeId === '3') {
              this.s2s3.push(element);
            }
          });

          // total horas s1
          this.sumTempS1 = 0;
          this.s1.forEach(element => {
            this.sumTempS1 = this.sumTempS1 + Number(element.hours);
          });

          // total horas s2 y s3
          this.sumTempS2 = 0;
          this.sumTempS3 = 0;
          this.s2s3.forEach(element => {
            if (element.activityTypeId === '2') {
              this.sumTempS2 = this.sumTempS2 + Number(element.hours);
            }
            if (element.activityTypeId === '3') {
              this.sumTempS3 = this.sumTempS3 + Number(element.hours);
            }
          });

          this.sumTempTotal = 0;
          this.sumTempTotal = this.sumTempS1 + this.sumTempS2 + this.sumTempS3;

          this.workingDay = data.workingDay;
          this.festive = data.festive;
          this.newDate = this.getDay(data.date) + '/' + this.getMonth(data.date) + '/' + this.getYear(data.date);
        }
      }),

      this._observatoryService.getData('imputationS1').subscribe(data => {
        if (data) {
          this.modifiedS1 = Object.assign([], data);
          if (this.modifiedS1.length) {
            this.sumTempS1 = 0;
            this.modifiedS1.forEach(element => {
              this.sumTempS1 = this.sumTempS1 + Number(element.hours);
            });
            this.sumTempTotal = 0;
            this.sumTempTotal = this.sumTempS1 + this.sumTempS2 + this.sumTempS3;
          }
        }
      }),

      this._observatoryService.getData('imputationS2S3').subscribe(data => {
        if (data) {
          this.modifiedS2S3 = Object.assign([], data);
          // if (this.modifiedS2S3.length) {
          this.sumTempS2 = 0;
          this.sumTempS3 = 0;
          this.modifiedS2S3.forEach(element => {
            if (element.activityTypeId === '2') {
              this.sumTempS2 = this.sumTempS2 + Number(element.hours);
            }
            if (element.activityTypeId === '3') {
              this.sumTempS3 = this.sumTempS3 + Number(element.hours);
            }
          });
          this.sumTempTotal = 0;
          this.sumTempTotal = this.sumTempS1 + this.sumTempS2 + this.sumTempS3;
        }
        // }
      }),

      this._observatoryService.getData('timeInPerson').subscribe(data => {
        if (data) {
          this.timeInPerson = data;
        }
      }),

    );

  }

  closeImputations(): void {
    // reiniciamos la array de horas
    this.rangeHourService.resetDayHours();

    // borramos la array anterior
    this.inputDayData.imputations = [];

    // llenamos con las nuevas imputaciones
    this.inputDayData.imputations = this.modifiedS1.concat(this.modifiedS2S3);

    // damos formato
    this.inputDayData.imputations = this.convertImputationsToSend(this.inputDayData.imputations);

    if (this.cleanEmptyRows()) {

      if (this.inputDayData.imputations) {
        const tipoS1 = this.inputDayData.imputations.find((imp: ImputationsData) => imp.activityTypeId === '1');
        if (!tipoS1 && this.festive === 'F') {
          this.notification.setError(this.translate.instant('CALENDARIO.NO_S1_IMPUT'));
          return;
        }
        if (this.validarImputaciones()) {
          this.close();
        }
      } else {
        this.close();
      }

    }
  }

  close(): void {
    // borramos las imputaciones guardadas
    this._observatoryService.setData('imputationS1', []);
    this._observatoryService.setData('imputationS2S3', []);
    this.modalService.dismissAll();
  }

  saveImputations() {

    // reiniciamos la array de horas
    this.rangeHourService.resetDayHours();

    // borramos la array anterior
    this.inputDayData.imputations = [];

    // llenamos con las nuevas imputaciones
    this.inputDayData.imputations = this.modifiedS1.concat(this.modifiedS2S3);

    // damos formato
    this.inputDayData.imputations = this.convertImputationsToSend(this.inputDayData.imputations);


    if (this.cleanEmptyRows()) {

      if (this.inputDayData.imputations) {
        const tipoS1 = this.inputDayData.imputations.find((imp: ImputationsData) => imp.activityTypeId === '1');
        if (!tipoS1 && this.festive === 'F') {
          this.notification.setError(this.translate.instant('CALENDARIO.NO_S1_IMPUT'));
          return;
        }
        if (this.validarImputaciones()) {
          this.subscriptions.push(
            this._modalDayService.saveSelectDay(this.inputDayData).subscribe(data => {
              if (data.response === 'OK') {
                this.close();
                this.notification.setSuccess(this.translate.instant('CALENDARIO.CORRECTIMPUT'));
                this.update.emit();
              }
            })
          );
        }
      } else {
        this.close();
      }

    }
  }

  validarImputaciones(): boolean {

    if (this.sumTempS1 + this.sumTempS2 + this.sumTempS3 > 24) {
      this.notification.setError(this.translate.instant('CALENDARIO.TOTAL_IMPUT_HRS'));
      return false;
    }

    // tslint:disable-next-line:forin
    for (const i in this.inputDayData.imputations) {

      // tiempo de descanso negativo
      if (this.inputDayData.imputations[i].breakTime < 0) {
        this.notification.setError(this.translate.instant('CALENDARIO.REST_TIME_POSITIVE'));
        return false;
      }
      // tiempo de descanso mayor que la jornada laboral
      if (this.inputDayData.imputations[i].breakTime > this.workingDay) {
        this.notification.setError(this.translate.instant('CALENDARIO.REST_TIME_LOWER'));
        return false;
      }
      // tiempo de descanso multiplo de 0.5
      if (this.inputDayData.imputations[i].activityTypeId === '1' && this.inputDayData.imputations[i].breakTime % 0.5 !== 0) {
        this.notification.setError(this.translate.instant('CALENDARIO.REST_TIME_MULTIPL'));
        return false;
      }
      // horas multiplo de 0.5
      if (this.inputDayData.imputations[i].hours % 0.5 !== 0) {
        this.notification.setError(this.translate.instant('CALENDARIO.HOURS_MULTIPL'));
        return false;
      }
      // tiene hora de incio y fin?
      if ('startTime' in this.inputDayData.imputations[i] && 'endTime' in this.inputDayData.imputations[i]) {
        // hora inicio mayor que hora fin
        if (this.makeDate(this.inputDayData.imputations[i].startTime) >= this.makeDate(this.inputDayData.imputations[i].endTime)) {
          this.notification.setError(this.translate.instant('CALENDARIO.HR_ENTR'));
          return false;
        }
      } else {
        this.notification.setError(this.translate.instant('CALENDARIO.HR_MANDATORY'));
        return false;
      }
      if (!this.inputDayData.imputations[i].hours || !this.inputDayData.imputations[i].sapId || !this.inputDayData.imputations[i].activityTypeId) {
        this.notification.setError(this.translate.instant('CALENDARIO.REQUIRED_PHA_S2S3'));
        return false;
      }
      if (this.inputDayData.imputations[i].activityTypeId === '1' && (Number(this.timeInPerson) !== this.sumTempS1 || Number(this.inputDayData.imputations[i].hours) < 0.5)) {
        if (Number(this.timeInPerson) < this.sumTempS1) {
          this.notification.setError(this.translate.instant('CALENDARIO.S1_OFFICE_LIMIT_SUP') + this.timeInPerson + this.translate.instant('CALENDARIO.NO_IMPUT_DONE'));
        } else {
          this.notification.setError(this.translate.instant('CALENDARIO.S1_OFFICE_LIMIT_INF') + this.timeInPerson + this.translate.instant('CALENDARIO.NO_IMPUT_DONE'));
        }
        return false;
      }

    }

    // validamos que las horas no coincidan en el tiempo
    return this.validateHours();
  }

  validateHours() {
    // llenamos la array a validar con el primer elemento de s1 (ya que todas las s1 tienen la mima hora de entrada y salida) y todas las imputaciones s2 y s3
    const imputations = this.modifiedS2S3;
    if (this.festive === 'F') {
      imputations.splice(0, 0, this.modifiedS1[0]);
    }

    for (const i in imputations) {
      if (this.rangeHourService.setRangeHour(imputations[i].startTime, imputations[i].endTime) === 'error') {
        this.notification.setError(this.translate.instant('CALENDARIO.OVERLAP_HRS') + imputations[i].startTime + '-' + imputations[i].endTime + this.translate.instant('CALENDARIO.IN_PROJ') + imputations[i].sapId);
        return false;
      }
    }
    return true;
  }

  makeDate(data) {
    const date = new Date();
    date.setHours(Number(this.getHH(data)));
    date.setMinutes(Number(this.getMM(data)));
    date.setSeconds(Number(this.getSS(data)));

    return date;
  }

  convertImputationsToSend(imputations: Array<ImputationsData>): Array<ImputationsData> {
    if (imputations.length) {
      for (const i in imputations) {
        if (imputations[i].hours) {
          imputations[i].hours = imputations[i].hours.toString();
        }
      }
      return imputations;
    }
  }

  cleanEmptyRows(): boolean {
    if (this.inputDayData.imputations) {
      for (let i = 0; i < this.inputDayData.imputations.length; i++) {
        if (!this.inputDayData.imputations[i].projectId && !this.inputDayData.imputations[i].sapId &&
          !this.inputDayData.imputations[i].hours) { // && !this.inputDayData.imputations[i].activityTypeId
          this.inputDayData.imputations.splice(i--, 1);
        }
      }
    }
    return true;
  }

  private getDay(fecha): string {
    return fecha.substring(6, 8);
  }

  private getMonth(fecha): string {
    return fecha.substring(4, 6);
  }

  private getYear(fecha): string {
    return fecha.substring(0, 4);
  }

  tabChange(ev) {
    // console.log(ev.index);
  }

  private getHH(fecha): string {
    return fecha.substring(0, 2);
  }

  private getMM(fecha): string {
    return fecha.substring(3, 5);
  }

  private getSS(fecha): string {
    return fecha.substring(6, 8);
  }

  /**
   * @name ngOnDestroy
   * @description Lifecycle hook
   */
  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }

}
